import styled from 'styled-components';
import { TextLinkBack } from '@nebula/text-link';
import { TitleLarge500, TitleMedium500, TitleXLarge500 } from '@nebula/global-styles';

export const ReviewAndPayContainer = styled.div(
  ({ theme, isWebview }) => `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  ${isWebview ? 'padding-top: 0px;' : ''}
  background: ${theme.color.ui.grey[10]};
  
  @media ${theme.media.tabletPortraitMin} {
    padding: 24px;
  }
  
  @media ${theme.media.tabletLandscapeMin} {
    padding: 32px 112px;
  }
`
);

export const ReviewAndPayContent = styled.div`
  width: 100%;
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    width: 802px;
  }
`;

export const BackLink = styled(TextLinkBack)`
  padding-left: 8px;
`;

export const StyledTitleXLarge500 = styled(TitleXLarge500)`
  line-height: 40px;
`;

export const StyledTitleLarge500 = styled(TitleLarge500)`
  line-height: 36px;
`;

export const StyledTitleMedium500 = styled(TitleMedium500)`
  line-height: 32px;
`;
